import { render, staticRenderFns } from "./MediaManager.vue?vue&type=template&id=fac873fe"
import script from "./MediaManager.vue?vue&type=script&lang=js"
export * from "./MediaManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports